<div class="minimize-sidebar-button">
    <ui-map-button>
        <ui-icon
            aria-hidden
            [icon]="'sidebar-hide'"
        />
    </ui-map-button>
</div>
